
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import HitPayCheckout from "../components/HitPayCheckout";
import { NotificationManager } from "react-notifications";
import "../assets/css/Cart.css";
import ServiceCart from "../assets/images/servicecart.png";
import Footer from '../components/Footer'
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";

const Cart = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { cart, setCartCount } = useCart();

  const [cartData, setCartData] = useState([]);
  const [paymentRequestId, setPaymentRequestId] = useState(null);
  const [checkoutUrl, setCheckoutUrl] = useState(null);

  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [agreed, setAgreed] = useState(false);

  const [address, setAddress] = useState({
    name: "",
    mobile: "",
    street: "",
    city: "",
    state: "",
    zip_code: "",
    lat: "",
    lon: "",
  });

  //  for calculation of tax
  function calculatePayNowFee(totalWithSurcharge) {
    let fee = 0.0;

    if (totalWithSurcharge >= 100) {
      fee = totalWithSurcharge * 0.0065 + 0.30; // 0.65% + S$0.30
    } else {
      fee = totalWithSurcharge * 0.009; // 0.90%
      if (fee < 0.20) {
        fee = 0.20; // minimum fee S$0.20
      }
    }

    return parseFloat(fee.toFixed(2));
  }

  // --- Fetch cart/bookings from API ---
  const fetchCart = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/api/booking/list/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status === 200) {
        setCartData(data.data);
        setCartCount(data.data)
      } else {
        NotificationManager.error("Failed to fetch bookings");
      }
    } catch (err) {
      console.error("Fetch bookings error:", err);
      NotificationManager.error("Failed to fetch bookings");
    }
  };

  // --- Fetch addresses from API ---
  const fetchAddresses = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/api/address/list/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      if (data.status === 200) {
        setAddresses(data.data);
        if (data.data.length > 0) setSelectedAddress(data.data[0]);
      }
    } catch (err) {
      console.error("Fetch addresses error:", err);
    }
  };

  useEffect(() => {
    fetchCart();
    fetchAddresses();
  }, []);

  // --- Delete booking ---
  const handleDeleteBooking = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/api/booking/${id}/delete/`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();
      if (data.status === 200) {
        // setCartData((prev) => prev.filter((b) => b.id !== id));
        const updatedCart = cartData.filter((b) => b.id !== id);
        setCartData(updatedCart);
        setCartCount(updatedCart)
        NotificationManager.success("Booking removed!");
      } else {
        NotificationManager.error("Failed to remove booking");
      }
    } catch (err) {
      console.error("Delete booking error:", err);
      NotificationManager.error("Failed to remove booking");
    }
  };

  // --- Calculate subtotal ---
  const subtotal = cartData.reduce((acc, item) => {
    const price = parseFloat(item.price?.toString().replace(/[^\d.]/g, ""));
    return acc + (isNaN(price) ? 0 : price);
  }, 0);

  // --- Address handlers ---
  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const fetchLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setAddress((prev) => ({
            ...prev,
            lat: latitude.toString(),
            lon: longitude.toString(),
          }));
        },
        (error) => {
          console.error("Error fetching location: ", error);
          NotificationManager.error("Failed to fetch location", "", 10000);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const handleSaveAddress = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    if (!address.name || !address.mobile || !address.street) {
      NotificationManager.warning("Please fill required fields");
      return;
    }

    try {
      const endpoint = editingAddressId
        ? `${process.env.REACT_APP_HOST_API_URL}/api/address/${editingAddressId}/update/`
        : `${process.env.REACT_APP_HOST_API_URL}/api/address/add/`;

      const method = editingAddressId ? "PUT" : "POST";

      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: address.name,
          mobile: address.mobile,
          address: `${address.street}, ${address.city}, ${address.state}`,
          zip_code: address.zip_code,
          lat: address.lat,
          lon: address.lon,
        }),
      });

      const data = await res.json();

      if (data.status === 200) {
        if (editingAddressId) {
          setAddresses((prev) =>
            prev.map((addr) =>
              addr.id === editingAddressId ? { ...addr, ...data.data } : addr
            )
          );
          NotificationManager.success("Address updated successfully");
        } else {
          setAddresses((prev) => [...prev, data.data]);
          NotificationManager.success("Address added successfully");
        }
        setShowForm(false);
        setEditingAddressId(null);
        setAddress({
          name: "",
          mobile: "",
          street: "",
          city: "",
          state: "",
          zip_code: "",
          lat: "",
          lon: "",
        });
      } else {
        NotificationManager.error(data.message || "Failed to save address");
      }
    } catch (err) {
      console.error("Save address error:", err);
    }
  };

  const handleEditAddress = (addr) => {
    setEditingAddressId(addr.id);
    const parts = addr.address?.split(",") || [];
    setAddress({
      name: addr.name,
      mobile: addr.mobile,
      street: parts[0] || "",
      city: parts[1]?.trim() || "",

      zip_code: addr.zip_code || "",
      lat: addr.lat || "",
      lon: addr.lon || "",
    });
    setShowForm(true);
  };

  const handleDeleteAddress = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/api/address/${id}/delete/`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (data.status === 200) {
        setAddresses((prev) => prev.filter((addr) => addr.id !== id));
        if (selectedAddress?.id === id) setSelectedAddress(null);
        NotificationManager.success("Address deleted successfully");
      }
    } catch (err) {
      console.error("Delete address error:", err);
    }
  };

  // --- Checkout ---
  const handleCheckoutClick = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      NotificationManager.warning("Please login to proceed with payment.", "Login Required");
      navigate("/login");
      return;
    }

    if (!selectedAddress) {
      NotificationManager.warning("Please select an address first.");
      return;
    }
    if (!agreed) {
      NotificationManager.warning("You must agree to the Terms & Conditions to proceed.");
      return;
    }
    const bookingIds = cartData.map((item) => item.id);
    if (bookingIds.length === 0) {
      NotificationManager.warning("No bookings available for payment.");
      return;
    }

    const fee = calculatePayNowFee(subtotal);
    const totalAmount = parseFloat((subtotal + fee).toFixed(2));
    try {
      setLoading(true)
      const response = await fetch(`${process.env.REACT_APP_HOST_API_URL}/payment/create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          amount: totalAmount,
          tax: fee,
          redirect_url: "https://www.universalhra.com/",
          booking_address: selectedAddress?.id || null,
          booking_service_ids: bookingIds
        }),
      });


      const data = await response.json();
      if (data.checkout_url || data.payment_request?.payment_request_id) {
        setPaymentRequestId(data.payment_request.payment_request_id);
        setCheckoutUrl(data.checkout_url);
      } else {
        NotificationManager.error("Could not get payment request id.", "Error");
      }
    } catch (err) {
      console.error("Checkout error:", err);
    }finally{
      setLoading(false)
    }
  };

  return (
    <div>
      <div className="child-nav bg-white">
        <Navbar />
      </div>

      <div className="container mt-4">
        <h2 className="mb-4" style={{ color: "#0564bf" }}>
          Your Cart
        </h2>

        {cartData.length === 0 ? (
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h5 className="text-muted">🛒 Your cart is empty.</h5>
            <div
              className="mt-3"
              style={{
                backgroundImage: `url(${ServiceCart})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: "100%",
                height: "300px",
                maxWidth: "400px",
              }}
            ></div>
          </div>
        ) : (
          <div className="row">
            <div className="col-12 col-lg-8">
              {/* Address Section */}
              <div className="cart-item px-4 py-4 mb-4">
                <h5 className="card-title">Service Address</h5>
                <hr />

                {addresses.length > 0 && (
                  <div className="mb-3">
                    {addresses.map((addr) => (
                      <div
                        key={addr.id}
                        className="border rounded p-2 mb-2 d-flex align-items-start"
                      >
                        <input
                          type="radio"
                          name="selectedAddress"
                          checked={selectedAddress?.id === addr.id}
                          onChange={() => setSelectedAddress(addr)}
                          className="me-2 mt-1"
                        />
                        <div className="flex-grow-1">
                          <p>
                            <strong>{addr.name}</strong>
                          </p>
                          <p>
                            {addr.address} {addr.zip_code}
                          </p>
                          <p>📞 {addr.mobile}</p>
                        </div>
                        <button
                          className="btn btn-sm btn-outline-primary ms-2"
                          onClick={() => handleEditAddress(addr)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger ms-2"
                          onClick={() => handleDeleteAddress(addr.id)}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {!showForm ? (
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => setShowForm(true)}
                  >
                    + Add New Address
                  </button>
                ) : (
                  <form className="mt-2">
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={address.name}
                      onChange={handleAddressChange}
                      className="form-control mb-2"
                    />
                    <input
                      type="text"
                      name="mobile"
                      placeholder="Mobile Number"
                      value={address.mobile}
                      onChange={handleAddressChange}
                      className="form-control mb-2"
                    />
                    <input
                      type="text"
                      name="street"
                      placeholder="Street"
                      value={address.street}
                      onChange={handleAddressChange}
                      className="form-control mb-2"
                    />
                    <div className="row mb-2">
                      <div className="col">
                        <input
                          type="text"
                          name="city"
                          placeholder="Town/area"
                          value={address.city}
                          onChange={handleAddressChange}
                          className="form-control"
                        />
                      </div>

                    </div>
                    <input
                      type="text"
                      name="zip_code"
                      placeholder="Zip Code"
                      value={address.zip_code}
                      onChange={handleAddressChange}
                      className="form-control mb-2"
                    />
                    <div className="d-flex gap-2 mb-2">
                      <input
                        type="text"
                        name="lat"
                        placeholder="Latitude"
                        value={address.lat}
                        readOnly
                        className="form-control"
                      />
                      <input
                        type="text"
                        name="lon"
                        placeholder="Longitude"
                        value={address.lon}
                        readOnly
                        className="form-control"
                      />
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={fetchLocation}
                      >
                        Use Current Location
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleSaveAddress}
                      >
                        {editingAddressId ? "Update Address" : "Save Address"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          setShowForm(false);
                          setEditingAddressId(null);
                          setAddress({
                            name: "",
                            mobile: "",
                            street: "",
                            city: "",
                            state: "",
                            zip_code: "",
                            lat: "",
                            lon: "",
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                )}
              </div>


              <ul className="list-group">
                {cartData.map((item) => {
                  let noteData = {};
                  try {
                    noteData = item.note ? JSON.parse(item.note) : {};
                  } catch (err) {
                    console.error("Failed to parse note:", err);
                  }

                  return (
                    <li
                      key={item.id}
                      className="list-group-item mb-3 px-3 py-3 cart-item d-flex justify-content-between align-items-center"
                    >
                      {/* Left: Note Details */}
                      <div className="d-flex flex-column flex-grow-1 me-3">
                        <h5 className="mb-2" style={{ color: "#0564bf" }}>
                          {noteData.service || "Service"}
                        </h5>
                        <div className="ps-2 small">
                          {Object.entries(noteData).map(([key, value]) => {
                            if (key === "service") return null;
                            return (
                              <div key={key} className="mb-1">
                                <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/*  Remove Button */}
                      <div>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDeleteBooking(item.id)}
                        >
                          Remove
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>

            </div>


            {/* Order Summary */}
            <div className="col-12 col-lg-4 mt-4 mt-lg-0">
              <div className="px-4 py-4 cart-item">
                <h5 className="card-title">Service Summary</h5>
                <hr />
                <p className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <strong>${subtotal.toFixed(2)}</strong>
                </p>
                <p className="d-flex justify-content-between fs-5">
                  <span>Convenience fee:</span>
                  <strong>${calculatePayNowFee(subtotal)} </strong>
                </p>
                <p className="d-flex justify-content-between fs-5">
                  <span>Total:</span>
                  <strong className="">  ${(subtotal + calculatePayNowFee(subtotal)).toFixed(2)}</strong>
                </p>
               
                <div className="form-check my-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="termsCheck"
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="termsCheck">
                    I agree with{" "}
                    <Link to="/conditions" className="text-primary text-decoration-none">
                      Terms & Conditions
                    </Link>
                  </label>
                </div>

                <div className="text-end mt-3">
                  <button className="btn btn-outline-primary" 
                   disabled={!agreed || paymentRequestId || loading}
                  onClick={handleCheckoutClick}>
                    {/* Review & Pay */}
                        {loading ? "Loading..." : "Review & Pay"}
                  </button>
                </div>

                {paymentRequestId && (
                  <HitPayCheckout checkoutUrl={checkoutUrl} paymentRequestId={paymentRequestId} />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="mb-5 cart-item px-4 py-4 mt-4 ">
                  <h4 className="fw-bold text-danger">Diclaimer</h4>
                  <p className="">The price displayed is based on the selected plan and room size.
                    Final charges may vary if the actual site conditions differ from the details provided
                    (e.g., larger room size, additional cleaning requirements, or unforeseen complexities).
                    Any adjustments will be communicated before service begins.</p>
                </div>
              </div>

            </div>

          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Cart;

